<template>
  <div style="width: 100%">
    <Toast />

    <div class>
      <div class="col-12 pa-0">
        <code
          id="source-code"
          ref="source-code"
          class="language-html"
          v-text="code"
        ></code>
      </div>

      <div class="col-12 py-0">
        <div class="row">
          <div class="col pa-0" cols="12" lg="6">
            <v-btn block color="primary" small tile @click="copy()"
              >Copiar código</v-btn
            >
          </div>

          <div class="col pa-0" cols="12" lg="6">
            <v-btn block color="accent" small tile @click="copyURL()"
              >Copiar enlace de llamada</v-btn
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { copyText } from "../lib/copy";

export default {
  name: "SourceCode",

  components: {
    Toast: () => import("../components/Toast")
  },

  computed: {
    code() {
      const parts = [
        "<!-- Fontumi Call Button -->",
        `<fontumi-call-button project-id="${this.user.uid}"></fontumi-call-button><script type="module" src="//fontumi.co/cdn/fontumi-call-button/fontumi-call-button.esm.js"><\/script><script nomodule="" src="//fontumi.co/cdn/fontumi-call-button/fontumi-call-button.js"><\/script>`,
        "<!-- // Fontumi Call Button -->"
      ];

      return parts.join("\n");
    },

    ...mapGetters({
      projet: "getProject",
      user: "getUser"
    })
  },

  methods: {
    copy() {
      copyText(this.code);
      this.setMessage({
        message: "Código copiado correctamente.",
        color: "success"
      });
    },

    copyURL() {
      copyText(`https://fontumi.web.app/#/call?clientId=${this.user.uid}`);
      this.setMessage({
        message: "URL copiada correctamente.",
        color: "success"
      });
    },

    ...mapMutations(["setMessage"])
  }
};
</script>

<style scoped>
code {
  width: 100%;
  border-radius: 0;
  padding: 9px;
  tab-size: 2;
  box-shadow: none;
  text-align: left;
}
</style>
